import * as z from "zod/v4";

/**
 * Generic flow content node - can be any node type.
 * All nodes have a `type` property. The index signature allows
 * specific node interfaces to be assignable to this type.
 */
export interface FlowContentNode {
  type: string;
  [key: string]: unknown;
}

/**
 * Schema for validating flow content nodes.
 * Requires a type string and allows additional properties.
 */
export const FlowContentNodeSchema: z.ZodType<FlowContentNode> = z
  .object({ type: z.string() })
  .passthrough();
